(function () {
    'use strict';

    var config = window.MeilisearchProductGridConfig;
    if (!config) {
        console.error('[ms-grid] MeilisearchProductGridConfig not found.');
        return;
    }

    var MEILISEARCH_HOST = config.meilisearchHost;
    var MEILISEARCH_API_KEY = config.meilisearchApiKey;
    var MEILISEARCH_INDEX = config.meilisearchIndex;
    var collectionId = config.collectionId || null;
    var collectionHandle = config.collectionHandle || null;
    var currentLocale = config.currentLocale || 'de';
    var showOutOfStock = config.showOutOfStock !== false;
    var customerLoggedIn = config.customerLoggedIn === true;
    var marketHandle = config.marketHandle || '';
    var LAYOUT = config.layout || 'default';
    var SHOW_SALE_BADGES = config.showSaleBadges === true;
    var productsPerPage = (window.matchMedia('(max-width: 768px)').matches
        ? config.productsPerPageMobile
        : config.productsPerPageDesktop) || config.productsPerPage || 24;

    var T_NO_RESULTS = config.noResultsLabel || 'Keine Produkte gefunden.';

    var _search = null;
    var _searchInitialized = false;

    // Celluma concern chips (the `filter_von_concern` facet) toggle filtering
    var _concernRefine = null;
    var _activeConcerns = {};

    // AICO compare-at pricing (fetched in parallel after cards render; never blocks)
    var AICO_API = (typeof aico_get_data === 'function' && aico_get_data('API_URL')) || '';
    var _aicoCache = {};      // sku -> CHF value (number) or null when none
    var _aicoRequested = {};  // sku -> true once included in a request
    var _aicoObserver = null; // lazy-loads prices for cards near the viewport
    var _aicoPending = {};     // sku -> true, queued for the next batched flush
    var _aicoFlushTimer = null;

    var filterSettings = { filters: [], showOutOfStock: true };
    try {
        if (typeof config.filterSettings === 'string') {
            filterSettings = JSON.parse(config.filterSettings);
        } else if (config.filterSettings && typeof config.filterSettings === 'object') {
            filterSettings = config.filterSettings;
        }
    } catch (e) {
        console.error('[ms-grid] Error parsing filterSettings:', e);
    }

    function escapeHtml(text) {
        if (text == null) return '';
        var d = document.createElement('div');
        d.textContent = String(text);
        return d.innerHTML;
    }

    var SRCSET_WIDTHS = [200, 300, 420, 540, 720];
    var NO_IMAGE = 'https://aico.apps.aico.swiss/images/no-images.png';

    function shopifyImageUrl(src, width) {
        if (!src) return src;
        var sep = src.indexOf('?') !== -1 ? '&' : '?';
        return src + sep + 'width=' + width;
    }

    function shopifySrcset(src) {
        if (!src) return '';
        return SRCSET_WIDTHS
            .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
            .join(', ');
    }

    function getMainImageUrl(hit) {
        var img = (hit && hit.images && hit.images.length) ? hit.images[0] : null;
        if (!img) return '';
        return typeof img === 'string' ? img : (img.src || img.url || '');
    }

    function getLocalizedTitle(hit) {
        return hit['title_' + currentLocale] || hit.title || 'Produkt';
    }

    function getLocalizedHandle(hit) {
        return hit['handle_' + currentLocale] || hit.handle || '';
    }

    // Localized description HTML (base `description` is the German source)
    function getLocalizedDescription(hit) {
        return hit['description_' + currentLocale] || hit.description || '';
    }

    // Strip inline style/class attributes the description content ships with (page-builder junk), so our own styling applies
    function cleanDescriptionHtml(html) {
        if (!html) return '';
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        tmp.querySelectorAll('[style]').forEach(function (el) { el.removeAttribute('style'); });
        tmp.querySelectorAll('[class]').forEach(function (el) { el.removeAttribute('class'); });
        return tmp.innerHTML;
    }

    // Localized concern list (base `filter_von_concern` is the German source)
    function getLocalizedConcerns(hit) {
        var v = hit['filter_von_concern_' + currentLocale];
        if (v == null) v = hit.filter_von_concern;
        if (typeof v === 'string') v = v.split(',');
        return Array.isArray(v) ? v : [];
    }

    // The (locale-aware) facet field that the concern chips refine
    function getConcernField() {
        return (currentLocale === 'fr' || currentLocale === 'en' || currentLocale === 'it')
            ? 'filter_von_concern_' + currentLocale
            : 'filter_von_concern';
    }

    // Base (German) concern values — used to pick the glow-dot colour
    function getBaseConcerns(hit) {
        var v = hit.filter_von_concern;
        if (typeof v === 'string') v = v.split(',');
        return Array.isArray(v) ? v : [];
    }

    // Hardcoded fallback colours by normalized base (German) concern; the `filter_concern_color` metaobject overrides/extends these below
    var CONCERN_GLOW = {
        akne: '#8edee6',
        antiaging: '#fd8e81',
        kontur: '#734ede',
        schmerzen: '#cd1060',
        haaraufbau: '#cd1060'
    };

    function normalizeConcern(v) {
        return String(v).toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    // Merge metaobject colours over the defaults, normalizing keys so a human value like "Anti-Aging" still matches.
    if (config.concernGlow && typeof config.concernGlow === 'object') {
        Object.keys(config.concernGlow).forEach(function (k) {
            var color = config.concernGlow[k];
            if (color) CONCERN_GLOW[normalizeConcern(k)] = color;
        });
    }

    // Bestseller flag (accepts 1 / "1" / true / "true"). Note: the index field name ends with a literal "?", so bracket access is required
    function isBestseller(hit) {
        if (!hit) return false;
        var v = hit['metafield_aico_metafields_celluma_bestseller?'];
        if (v == null) v = hit['metafield_aico_metafields_celluma_bestseller'];
        return v === 1 || v === '1' || v === true || v === 'true';
    }

    function isVariantAvailable(v) {
        return !!(v && v.availableForSale);
    }

    function findFirstAvailableIndex(variants) {
        if (!Array.isArray(variants)) return -1;
        for (var i = 0; i < variants.length; i++) {
            if (isVariantAvailable(variants[i])) return i;
        }
        return -1;
    }

    function getVariantDisplay(hit, variantIndex) {
        var variants = (hit && Array.isArray(hit.variants)) ? hit.variants : [];
        var idx = typeof variantIndex === 'number' ? variantIndex : 0;
        var variant = variants[idx] || variants[0] || null;
        var price = variant ? (parseFloat(variant.price) || 0) : 0;
        var compareAtPrice = variant ? (parseFloat(variant.compareAtPrice) || null) : null;
        return {
            variant: variant,
            price: price,
            compareAtPrice: compareAtPrice,
            onSale: compareAtPrice !== null && compareAtPrice > price,
            currency: (hit && hit.price && hit.price.currency) || config.currency || 'EUR'
        };
    }

    // AICO per-product price hiding: tag `afc_price_hidden_on` or delivery_status 3
    function getNormalizedTags(hit) {
        var raw = hit && hit.tags;
        if (typeof raw === 'string') raw = raw.split(',');
        if (!Array.isArray(raw)) return [];
        return raw.map(function (t) { return String(t).trim().toLowerCase(); });
    }

    function isPriceHidden(hit) {
        var tags = getNormalizedTags(hit);
        if (tags.indexOf('afc_price_hidden_on') !== -1) return true;
        if (tags.indexOf('delivery_status_3') !== -1) return true;
        return false;
    }

    function formatPrice(amount, currency) {
        return amount.toFixed(2) + ' ' + currency;
    }

    function sanitizeId(val) {
        return String(val).replace(/[^a-zA-Z0-9]/g, '_');
    }

    // Facet option markup — differs per layout
    function defaultOptionHtml(baseField, item) {
        var inputId = 'filter-' + sanitizeId(baseField) + '-' + sanitizeId(item.value);
        return (
            '<li class="filter-list__item">' +
            '<input type="checkbox" id="' + inputId + '" class="filter-checkbox" data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + '>' +
            '<label for="' + inputId + '" class="filter-option' + (item.isRefined ? ' filter-option--active' : '') + '">' +
            '<span class="filter-option__name">' + escapeHtml(item.label) + '</span>' +
            '<span class="filter-option__count">(' + item.count + ')</span>' +
            '</label>' +
            '</li>'
        );
    }

    function cellumaOptionHtml(baseField, item) {
        var inputId = 'filter-' + sanitizeId(baseField) + '-' + sanitizeId(item.value);
        return (
            '<li class="cf-item">' +
            '<label class="cf-label" for="' + inputId + '">' +
            '<input type="checkbox" id="' + inputId + '" class="cf-input" data-value="' + escapeHtml(item.value) + '"' + (item.isRefined ? ' checked' : '') + '>' +
            '<span class="cf-checkbox"></span>' +
            '<span class="cf-name">' + escapeHtml(item.label) + '</span>' +
            '</label>' +
            '</li>'
        );
    }

    function getFilterLabel(filter) {
        if (filter.translations && filter.translations[currentLocale]) {
            return filter.translations[currentLocale];
        }
        return filter.label || filter.meilisearchField;
    }

    function getEffectiveField(filter) {
        // `metafield_json_localized` filters are always treated as translatable
        var translatable = filter.translatable || filter.type === 'metafield_json_localized';
        if (translatable) {
            if (filter.meilisearchFields && filter.meilisearchFields[currentLocale]) {
                return filter.meilisearchFields[currentLocale];
            }
            if (currentLocale === 'fr' || currentLocale === 'en' || currentLocale === 'it') {
                return filter.meilisearchField + '_' + currentLocale;
            }
        }
        return filter.meilisearchField;
    }

    // "From" price prefix shown only when variants actually span a price range
    var FROM_PREFIX = { de: 'ab', fr: 'Depuis', it: 'da', en: 'from' };

    function hasPriceRange(hit) {
        var p = hit && hit.price;
        if (p && p.minPrice != null && p.maxPrice != null) {
            return parseFloat(p.minPrice) !== parseFloat(p.maxPrice);
        }
        var variants = (hit && Array.isArray(hit.variants)) ? hit.variants : [];
        var prices = variants.map(function (v) { return parseFloat(v && v.price); }).filter(function (x) { return !isNaN(x); });
        if (prices.length < 2) return false;
        return Math.min.apply(null, prices) !== Math.max.apply(null, prices);
    }

    // Bracket label after the AICO list price ("UVP, exkl. MwSt.") or the selling price ("B2B-Preis, exkl. MwSt."); texts from the theme locales (window.aicoPriceLabels, set in theme.liquid)
    function priceLabel(type) {
        var labels = window.aicoPriceLabels;
        var text = labels && labels[type];
        return text ? '<span class="product-price__label product-price__label--' + type + '">(' + escapeHtml(text) + ')</span>' : '';
    }

    // Price inner markup. On sale: compare-at first (crossed out), then the selling price (highlighted) — both carry the "from" prefix when present. withLabels (AICO list price only): a bracket label after each price, one pair per line
    function buildPriceInner(shopPrice, compareVal, fromLabel, currency, withLabels) {
        function fromSpan(mod) {
            return fromLabel ? '<span class="product-price__from' + (mod ? ' ' + mod : '') + '">' + escapeHtml(fromLabel) + '</span> ' : '';
        }
        var current = '<span class="product-price__current' + (compareVal != null ? ' product-price__current--sale' : '') + '">' +
            escapeHtml(formatPrice(shopPrice, currency)) + '</span>';
        if (compareVal != null) {
            var compare = '<span class="product-price__compare">' + escapeHtml(formatPrice(compareVal, currency)) + '</span>';
            if (withLabels && priceLabel('uvp')) {
                return '<span class="product-price__line">' + fromSpan('product-price__from--compare') + compare + ' ' + priceLabel('uvp') + '</span>' +
                    '<span class="product-price__line">' + fromSpan('product-price__from--sale') + current + ' ' + priceLabel('b2b') + '</span>';
            }
            // "ab" before the compare matches the crossed-out style; "ab" before the selling price matches its highlight colour
            return fromSpan('product-price__from--compare') + compare + ' ' +
                fromSpan('product-price__from--sale') + current;
        }
        return fromSpan() + current;
    }

    function getHitPriceHtml(hit, activeIndex) {
        if (!customerLoggedIn || isPriceHidden(hit)) return '';
        var d = getVariantDisplay(hit, activeIndex);
        var variants = Array.isArray(hit.variants) ? hit.variants : [];
        var ranged = hasPriceRange(hit);
        var fromLabel = ranged ? (FROM_PREFIX[currentLocale] || '') : '';
        // With a price range, "ab/from" means the lowest price (price.minPrice)
        var shopPrice = d.price;
        if (ranged && hit.price && hit.price.minPrice != null) shopPrice = parseFloat(hit.price.minPrice);
        // SKUs (all variants) + per-variant prices, so the async AICO compare-at lookup can compare against the SAME variant the AICO value is anchored to (sku:price pairs), mirroring the PDP and avoiding false discounts
        var skus = variants.map(function (v) { return v && v.sku; }).filter(Boolean).join(',');
        var variantPrices = variants.map(function (v) {
            return (v && v.sku) ? v.sku + ':' + (parseFloat(v.price) || 0) : '';
        }).filter(Boolean).join(',');
        var compareVal = d.onSale ? d.compareAtPrice : null; // native Meilisearch compare-at (wins over AICO)
        return (
            '<div class="product-card__price" data-skus="' + escapeHtml(skus) + '" data-variant-prices="' + escapeHtml(variantPrices) + '" data-price="' + shopPrice + '" data-currency="' + escapeHtml(d.currency) + '" data-from="' + escapeHtml(fromLabel) + '" data-native-sale="' + (compareVal != null ? '1' : '0') + '">' +
            buildPriceInner(shopPrice, compareVal, fromLabel, d.currency) +
            '</div>'
        );
    }

    // AICO compare-at pricing (async, non-blocking)
    function aicoChunk(arr, n) {
        var out = [];
        for (var i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
        return out;
    }

    // Apply cached AICO values to one card's price element: cross out the AICO CHF price only when it's higher than the displayed selling price. Add the "Sale" badge to a card's media if it isn't there yet
    function addSaleBadge(priceEl) {
        if (!SHOW_SALE_BADGES) return;
        var card = priceEl.closest('.product-card');
        var media = card && card.querySelector('.product-card__media');
        if (media && !media.querySelector('.product-card__badges')) {
            var badges = document.createElement('div');
            badges.className = 'product-card__badges';
            badges.innerHTML = '<span class="product-card__badge product-card__badge--sale">Sale</span>';
            media.appendChild(badges);
        }
    }

    function variantPriceFor(attr, sku) {
        if (!attr) return null;
        var parts = attr.split(',');
        for (var i = 0; i < parts.length; i++) {
            var kv = parts[i].split(':');
            if (kv[0] === sku) return parseFloat(kv[1]);
        }
        return null;
    }

    function applyAicoToCard(priceEl) {
        if (priceEl.getAttribute('data-aico-applied') === '1') return;
        // Native Meilisearch compare-at always wins — don't let AICO override it
        if (priceEl.getAttribute('data-native-sale') === '1') {
            priceEl.setAttribute('data-aico-applied', '1');
            return;
        }
        var skus = (priceEl.getAttribute('data-skus') || '').split(',');
        var shopPrice = parseFloat(priceEl.getAttribute('data-price'));
        if (isNaN(shopPrice)) return;
        var aicoVal = null, matchedSku = null;
        for (var i = 0; i < skus.length; i++) {
            if (skus[i] && _aicoCache[skus[i]] != null) { aicoVal = _aicoCache[skus[i]]; matchedSku = skus[i]; break; }
        }
        if (aicoVal == null) return; // not resolved yet — try again on next pass
        priceEl.setAttribute('data-aico-applied', '1');
        // Compare against the price of the variant the AICO value belongs to (its sku), like the PDP, not the displayed min
        var cmpPrice = variantPriceFor(priceEl.getAttribute('data-variant-prices'), matchedSku);
        if (cmpPrice == null) cmpPrice = shopPrice;
        if (!(aicoVal > cmpPrice)) return; // not higher → no compare-at
        var currency = priceEl.getAttribute('data-currency') || 'CHF';
        var fromLabel = priceEl.getAttribute('data-from') || '';
        priceEl.innerHTML = buildPriceInner(shopPrice, aicoVal, fromLabel, currency, true);
        addSaleBadge(priceEl);
    }

    function applyAicoAll() {
        document.querySelectorAll('.product-card__price[data-skus]').forEach(applyAicoToCard);
    }

    // Fetch the queued SKUs in one go (chunked, parallel); applied as they land
    function aicoFlush() {
        if (_aicoFlushTimer) { clearTimeout(_aicoFlushTimer); _aicoFlushTimer = null; }
        var skus = Object.keys(_aicoPending).filter(function (s) { return !_aicoRequested[s]; });
        _aicoPending = {};
        if (!skus.length) return;
        skus.forEach(function (s) { _aicoRequested[s] = true; });

        var headers = { Accept: 'application/vnd.api+json' };
        aicoChunk(skus, 100).forEach(function (chunk) {
            var url = AICO_API + 'products?filter[sku]=' + chunk.map(encodeURIComponent).join(',') + '&page[size]=300';
            fetch(url, { headers: headers })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (body) {
                    if (!body || !Array.isArray(body.data)) return;
                    body.data.forEach(function (p) {
                        var a = p && p.attributes;
                        if (!a || !a.sku) return;
                        var v = (Array.isArray(a.productPrices) && a.productPrices.length)
                            ? parseFloat(a.productPrices[0].value)
                            : NaN;
                        // A SKU can map to several AICO products (duplicate/stub entries with value 0); ignore non-positive and keep the highest real price so a stub can't overwrite the good value
                        if (isNaN(v) || v <= 0) return;
                        if (_aicoCache[a.sku] == null || v > _aicoCache[a.sku]) _aicoCache[a.sku] = v;
                    });
                    applyAicoAll();
                })
                .catch(function () { });
        });
    }

    // Fire the first screenful's price request straight from the hits data, before the (expensive) DOM render — so the round-trip starts ASAP
    var AICO_PREFETCH = 36;
    function prefetchAicoFromHits(hits) {
        if (!AICO_API || !customerLoggedIn) return;
        var n = Math.min(AICO_PREFETCH, hits.length);
        for (var i = 0; i < n; i++) {
            var variants = Array.isArray(hits[i].variants) ? hits[i].variants : [];
            for (var j = 0; j < variants.length; j++) {
                var s = variants[j] && variants[j].sku;
                if (s && !_aicoRequested[s] && _aicoCache[s] == null) _aicoPending[s] = true;
            }
        }
        aicoFlush(); // don't wait for the debounce/observer
    }

    // Queue a card's SKUs and debounce a batched flush
    function queueAicoCard(priceEl) {
        (priceEl.getAttribute('data-skus') || '').split(',').forEach(function (s) {
            if (s && !_aicoRequested[s] && _aicoCache[s] == null) _aicoPending[s] = true;
        });
        if (!_aicoFlushTimer) _aicoFlushTimer = setTimeout(aicoFlush, 150);
    }

    // Lazy: only fetch prices for cards near the viewport; more as you scroll
    function observeAicoCards() {
        if (!AICO_API || !customerLoggedIn) return;
        var els = document.querySelectorAll('.product-card__price[data-skus]');

        if (typeof IntersectionObserver === 'undefined') {
            els.forEach(queueAicoCard); // fallback: queue them all
            return;
        }
        if (!_aicoObserver) {
            _aicoObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    _aicoObserver.unobserve(entry.target);
                    queueAicoCard(entry.target);
                });
            }, { rootMargin: '300px 0px' });
        }
        _aicoObserver.disconnect(); // drop stale (detached) observations from prior renders
        els.forEach(function (el) {
            if (el.getAttribute('data-aico-applied') !== '1') _aicoObserver.observe(el);
        });
    }

    // On sale if ANY variant has a compare-at price greater than its price
    function isHitOnSale(hit) {
        var variants = (hit && Array.isArray(hit.variants)) ? hit.variants : [];
        for (var i = 0; i < variants.length; i++) {
            var p = parseFloat(variants[i].price);
            var c = parseFloat(variants[i].compareAtPrice);
            if (!isNaN(p) && !isNaN(c) && c > 0 && c > p) return true;
        }
        return false;
    }

    // Ultimate Wishlist (UWL) button. The app fills empty .uwl-col-wishlist divs on page load, but our cards render after load, so we render the heart here. data-price is in cents to match the theme's card-product convention
    function getWishlistHtml(hit, d, title) {
        var productId = hit.id == null ? '' : String(hit.id);
        var variantId = (d.variant && d.variant.id != null) ? String(d.variant.id) : '';
        var priceCents = (d.price != null && !isNaN(d.price)) ? String(Math.round(d.price * 100)) : '';
        return (
            '<div class="uwl-col-wishlist aico-wishlist"' +
            ' data-productid="' + escapeHtml(productId) + '"' +
            ' data-variant="' + escapeHtml(variantId) + '"' +
            ' data-title="' + escapeHtml(title) + '"' +
            ' data-price="' + escapeHtml(priceCents) + '">' +
            '<svg width="20" height="20" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zm128 0q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z"></path>' +
            '</svg>' +
            '</div>'
        );
    }

    function renderHitHtml(hit) {
        var title = getLocalizedTitle(hit);
        var handle = getLocalizedHandle(hit);
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = rootPath + 'products/' + handle;

        var variants = Array.isArray(hit.variants) ? hit.variants : [];
        var firstAvail = findFirstAvailableIndex(variants);
        var activeIndex = firstAvail >= 0 ? firstAvail : 0;
        var d = getVariantDisplay(hit, activeIndex);
        var imgSrc = getMainImageUrl(hit);

        return (
            '<li class="product-grid__item">' +
            '<div class="product-card">' +
            getWishlistHtml(hit, d, title) +
            '<a class="product-card__media" href="' + escapeHtml(url) + '">' +
            (imgSrc
                ? '<img class="product-card__image" src="' + escapeHtml(shopifyImageUrl(imgSrc, 420)) +
                '" srcset="' + escapeHtml(shopifySrcset(imgSrc)) +
                '" sizes="(max-width: 768px) 50vw, 25vw" alt="' + escapeHtml(title) +
                '" loading="lazy" width="210" height="210" />'
                : '<img class="product-card__image" src="' + NO_IMAGE + '" alt="' + escapeHtml(title) + '" loading="lazy" width="210" height="210" />') +
            (SHOW_SALE_BADGES && isHitOnSale(hit)
                ? '<div class="product-card__badges"><span class="product-card__badge product-card__badge--sale">Sale</span></div>'
                : '') +
            '</a>' +
            '<div class="product-card__content">' +
            '<div class="product-card__title-wrap">' +
            '<a class="product-card__title" lang="' + escapeHtml(currentLocale) + '" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>' +
            '</div>' +
            getHitPriceHtml(hit, activeIndex) +
            '</div>' +
            '</div>' +
            '</li>'
        );
    }

    // Celluma tile renderer (only used for the ledcelluma-3511 layout). BEST SELLER and concerns are still hardcoded per spec; description is the hit field
    function renderCellumaHit(hit) {
        var title = getLocalizedTitle(hit);
        var handle = getLocalizedHandle(hit);
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = rootPath + 'products/' + handle;
        var imgSrc = getMainImageUrl(hit);
        var descHtml = cleanDescriptionHtml(getLocalizedDescription(hit));

        var variants = Array.isArray(hit.variants) ? hit.variants : [];
        var firstAvail = findFirstAvailableIndex(variants);
        var d = getVariantDisplay(hit, firstAvail >= 0 ? firstAvail : 0);

        var concerns = getLocalizedConcerns(hit);
        var baseConcerns = getBaseConcerns(hit);
        var concernsHtml = concerns.length
            ? '<div class="product-tile-concerns"><ul class="product-tile-concerns__list">' +
            concerns.map(function (c, i) {
                var baseVal = baseConcerns[i] != null ? baseConcerns[i] : c;
                // Specific concern colour, else the `default` entry from the metaobject. No `default` entry -> no dot
                var glowColor = CONCERN_GLOW[normalizeConcern(baseVal)] || CONCERN_GLOW.default;
                var glow = glowColor
                    ? '<i class="product-tile-concerns__glow" style="--light-blue-dot:' + glowColor + '"></i>'
                    : '';
                return '<li class="product-tile-concerns__item">' +
                    '<p class="product-tile-concern' + (_activeConcerns[c] ? ' is-active' : '') + '" data-concern="' + escapeHtml(c) + '">' +
                    glow + escapeHtml(c) +
                    '</p></li>';
            }).join('') +
            '</ul></div>'
            : '';

        return (
            '<div class="celluma-tile">' +
            '<div class="celluma-tile__inner">' +
            '<a class="celluma-tile__link" href="' + escapeHtml(url) + '">' +
            '<div class="celluma-tile__media">' +
            '<div class="celluma-tile__image-wrap">' +
            (imgSrc
                ? '<img class="celluma-tile__image" src="' + escapeHtml(shopifyImageUrl(imgSrc, 540)) +
                '" srcset="' + escapeHtml(shopifySrcset(imgSrc)) +
                '" sizes="(max-width: 1024px) 50vw, 33vw" alt="' + escapeHtml(title) + '" loading="lazy" />'
                : '<img class="celluma-tile__image" src="' + NO_IMAGE + '" alt="' + escapeHtml(title) + '" loading="lazy" />') +
            '</div>' +
            getWishlistHtml(hit, d, title) +
            (isBestseller(hit) ? '<p class="celluma-tile__badge">BEST SELLER</p>' : '') +
            concernsHtml +
            '</div>' +
            '<div class="celluma-tile__info">' +
            '<div class="celluma-tile__info-row">' +
            '<h2 class="celluma-tile__title">' + escapeHtml(title) + '</h2>' +
            '</div>' +
            '<div class="celluma-tile__desc-wrap">' +
            '<div class="celluma-tile__desc">' + descHtml + '</div>' +
            '</div>' +
            '</div>' +
            '</a>' +
            '</div>' +
            '</div>'
        );
    }

    // Pick the renderer for the active layout
    var renderHit = LAYOUT === 'celluma' ? renderCellumaHit : renderHitHtml;

    // Reveal the full section (filters, sort, grid) and hide the loading ripple by adding `.is-ready`. Loading is the default state, so this works even if the server HTML doesn't carry a loading class. A minimum on-screen time guarantees the ripple is actually seen on fast loads
    var MIN_LOADER_MS = 1000;
    var _loadStart = Date.now();
    var _revealed = false;
    function revealSection() {
        if (_revealed) return;
        var elapsed = Date.now() - _loadStart;
        if (elapsed < MIN_LOADER_MS) {
            setTimeout(revealSection, MIN_LOADER_MS - elapsed);
            return;
        }
        _revealed = true;
        document.querySelectorAll('.collection-meili').forEach(function (el) {
            el.classList.add('is-ready');
        });
    }

    function checkAndInit() {
        if (_searchInitialized) return true;
        if (typeof window.instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
            _searchInitialized = true;
            resolveMarketFilter(startSearch);
            return true;
        }
        return false;
    }

    /* Hides products the visitor's market does not carry; an unknown field fails the whole query,
       so a market the settings do not list is probed once, and `!= false` keeps missing flags */
    function resolveMarketFilter(done) {
        if (!marketHandle) return done('');
        var advertised = ((filterSettings && filterSettings.markets) || []).filter(function (m) { return m.handle === marketHandle; })[0];
        var field = advertised ? advertised.publishedField : 'published_' + marketHandle;
        if (!field || !/^[A-Za-z0-9_-]+$/.test(field)) return done('');
        var filter = field + ' != false';
        if (advertised) return done(filter);

        var CACHE_KEY = 'msGridMarketFilter:' + MEILISEARCH_INDEX + ':' + field;
        try {
            var cached = sessionStorage.getItem(CACHE_KEY);
            if (cached !== null) return done(cached === '1' ? filter : '');
        } catch (e) {}

        var finished = false;
        function finish(ok) {
            if (finished) return;
            finished = true;
            try { sessionStorage.setItem(CACHE_KEY, ok ? '1' : '0'); } catch (e) {}
            if (!ok) console.warn('[ms-grid] Index has no ' + field + ', showing products of every market.');
            done(ok ? filter : '');
        }
        // A slow probe must not hold the grid back: past the timeout the grid loads unfiltered
        setTimeout(function () {
            if (finished) return;
            finished = true;
            done('');
        }, 3000);
        fetch(MEILISEARCH_HOST.replace(/\/$/, '') + '/indexes/' + encodeURIComponent(MEILISEARCH_INDEX) + '/search', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + MEILISEARCH_API_KEY },
            body: JSON.stringify({ q: '', limit: 0, filter: filter })
        }).then(function (res) { finish(res.ok); }, function () { finish(false); });
    }

    function initSearch() {
        // Safety net: never leave the section hidden if something goes wrong
        setTimeout(revealSection, 10000);
        if (checkAndInit()) return;
        var attempts = 0;
        var timer = setInterval(function () {
            attempts++;
            if (checkAndInit() || attempts > 50) {
                clearInterval(timer);
                if (attempts > 50) {
                    console.error('[ms-grid] InstantSearch libraries failed to load.');
                    revealSection();
                }
            }
        }, 100);
    }

    function startSearch(marketFilter) {
        var searchClient = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_API_KEY, {
            primaryKey: 'id',
            finitePagination: true,
            keepZeroFacets: false,
            paginationTotalHits: 1000
        });

        var baseFilters = [];
        if (collectionId) baseFilters.push('collections.id = ' + collectionId);
        // Guests never see products tagged for login-only visibility
        if (!customerLoggedIn) baseFilters.push('tags != "afc_hidden_nologin_on"');
        if (marketFilter) baseFilters.push(marketFilter);
        if (!showOutOfStock) baseFilters.push('(totalInventory > 0 OR variants.inventoryPolicy = "CONTINUE")');
        var baseFilterString = baseFilters.join(' AND ');

        var DEFAULT_SORT = MEILISEARCH_INDEX;
        // Sort applied on first load when no `sort` is present in the URL (default: title asc)
        var DEFAULT_UI_SORT = config.defaultSort ? (MEILISEARCH_INDEX + ':' + config.defaultSort) : DEFAULT_SORT;

        // A filter is shown when it isn't excluded on this collection and, if it has an includedOnCollections whitelist, this collection is in it. Lists may contain handles or collection ids
        var collectionIdStr = collectionId != null ? String(collectionId) : '';
        function matchesCurrentCollection(arr) {
            if (!arr || !arr.length) return false;
            return arr.indexOf(collectionHandle) !== -1 ||
                arr.indexOf(collectionIdStr) !== -1 ||
                (collectionId != null && arr.indexOf(collectionId) !== -1);
        }
        var sortedFilters = (filterSettings.filters || [])
            .filter(function (f) {
                if (matchesCurrentCollection(f.excludedOnCollections)) return false;
                if (f.includedOnCollections && f.includedOnCollections.length) {
                    return matchesCurrentCollection(f.includedOnCollections);
                }
                return true;
            })
            .sort(function (a, b) { return a.position - b.position; });

        var fieldLabelMap = {};
        // Map attribute -> the live refinement render state so the per-group "Aufheben" button can clear only that group
        var groupStateByAttr = {};
        sortedFilters.forEach(function (f) {
            var label = getFilterLabel(f);
            fieldLabelMap[f.meilisearchField] = label;
            var effField = getEffectiveField(f);
            if (effField !== f.meilisearchField) {
                fieldLabelMap[effField] = label;
            }
        });

        // On a language switch the URL's filter params reference the previous locale's facet values (e.g. "Akne" vs "Acné"), so drop them before the router reads the URL
        try {
            var LOCALE_KEY = 'msGridLocale';
            var prevLocale = sessionStorage.getItem(LOCALE_KEY);
            sessionStorage.setItem(LOCALE_KEY, currentLocale);
            if (prevLocale && prevLocale !== currentLocale) {
                // The old URL was written under the previous locale, so strip every locale variant of every filter key (incl. the concern-chip field, which isn't in sortedFilters)
                var ALL_LOCALES = ['de', 'fr', 'en', 'it'];
                var filterKeySet = { page: true };
                var addKey = function (field) {
                    filterKeySet[field.indexOf('filter_') === 0 ? field.slice(7) : field] = true;
                };
                var addAllVariants = function (baseField, fieldsMap) {
                    addKey(baseField);
                    ALL_LOCALES.forEach(function (loc) { addKey(baseField + '_' + loc); });
                    if (fieldsMap) Object.keys(fieldsMap).forEach(function (loc) { addKey(fieldsMap[loc]); });
                };
                sortedFilters.forEach(function (f) { addAllVariants(f.meilisearchField, f.meilisearchFields); });
                addAllVariants('filter_von_concern'); // concern chips, in case it isn't a configured sidebar filter
                var params = new URLSearchParams(window.location.search);
                var stripped = false;
                Object.keys(filterKeySet).forEach(function (k) {
                    if (params.has(k)) { params.delete(k); stripped = true; }
                });
                if (stripped) {
                    var qs = params.toString();
                    window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
                }
            }
        } catch (e) { /* sessionStorage unavailable (private mode) — skip */ }

        _search = window.instantsearch({
            indexName: DEFAULT_SORT,
            searchClient: searchClient.searchClient,
            insights: false,
            routing: {
                stateMapping: {
                    stateToRoute: function (uiState) {
                        var idx = uiState[Object.keys(uiState)[0]] || {};
                        var route = {};
                        if (idx.refinementList) {
                            Object.keys(idx.refinementList).forEach(function (attr) {
                                var vals = idx.refinementList[attr];
                                if (vals && vals.length) {
                                    var key = attr.indexOf('filter_') === 0 ? attr.slice(7) : attr;
                                    route[key] = vals.join(',');
                                }
                            });
                        }
                        if (idx.sortBy && idx.sortBy !== DEFAULT_UI_SORT) {
                            route.sort = idx.sortBy.replace(MEILISEARCH_INDEX + ':', '');
                        }
                        if (idx.page && idx.page > 1) {
                            route.page = idx.page;
                        }
                        return route;
                    },
                    routeToState: function (route) {
                        var reserved = { sort: true, q: true, page: true };
                        var filterKeys = {};
                        sortedFilters.forEach(function (f) {
                            var effField = getEffectiveField(f);
                            var short = f.meilisearchField.indexOf('filter_') === 0
                                ? f.meilisearchField.slice(7)
                                : f.meilisearchField;
                            filterKeys[short] = effField;
                            if (effField !== f.meilisearchField) {
                                var effShort = effField.indexOf('filter_') === 0 ? effField.slice(7) : effField;
                                filterKeys[effShort] = effField;
                            }
                        });
                        var refinementList = {};
                        Object.keys(route).forEach(function (key) {
                            if (reserved[key]) return;
                            var attr = filterKeys[key] || key;
                            if (route[key]) refinementList[attr] = route[key].split(',');
                        });
                        var state = {};
                        if (Object.keys(refinementList).length) state.refinementList = refinementList;
                        state.sortBy = route.sort ? (MEILISEARCH_INDEX + ':' + route.sort) : DEFAULT_UI_SORT;
                        if (route.page) {
                            var p = parseInt(route.page, 10);
                            if (!isNaN(p) && p > 1) state.page = p;
                        }
                        var uiState = {};
                        uiState[DEFAULT_SORT] = state;
                        return uiState;
                    }
                }
            }
        });

        // Intentionally load up to 1000 products in the first request (all on one page). paginationTotalHits is also 1000, so this covers the full set
        var configureOptions = { hitsPerPage: 1000 };
        if (baseFilterString) configureOptions.filters = baseFilterString;
        _search.addWidgets([window.instantsearch.widgets.configure(configureOptions)]);

        // Filters (refinement lists)
        sortedFilters.forEach(function (filter) {
            var baseField = filter.meilisearchField;
            var effectiveField = getEffectiveField(filter);
            var groupEl = document.getElementById('filter-group-' + baseField);
            var ul = document.getElementById('filter-options-' + baseField);
            if (!groupEl || !ul) return;

            var currentRefine = null;

            ul.addEventListener('change', function (e) {
                if (e.target.type === 'checkbox' && currentRefine) {
                    if (LAYOUT !== 'celluma') _scrollToTopPending = true; // modal stays put
                    currentRefine(e.target.dataset.value);
                }
            });

            var customRefinement = window.instantsearch.connectors.connectRefinementList(
                function (renderState, isFirstRender) {
                    currentRefine = renderState.refine;
                    groupStateByAttr[effectiveField] = renderState;
                    if (isFirstRender) return;
                    groupEl.style.display = renderState.items.length === 0 ? 'none' : '';
                    if (renderState.items.length === 0) return;

                    var optionHtml = LAYOUT === 'celluma' ? cellumaOptionHtml : defaultOptionHtml;
                    ul.innerHTML = renderState.items.map(function (item) {
                        return optionHtml(baseField, item);
                    }).join('');
                }
            );

            _search.addWidgets([customRefinement({
                attribute: effectiveField,
                operator: 'or',
                limit: 100,
                sortBy: ['name:asc']
            })]);

            // Per-group "Aufheben": clear only this facet's refinements
            var clearBtn = groupEl.querySelector('.filter-group__clear');
            if (clearBtn) {
                clearBtn.addEventListener('click', function () {
                    var rs = groupStateByAttr[effectiveField];
                    if (!rs || !rs.items) return;
                    _scrollToTopPending = true;
                    rs.items.forEach(function (item) {
                        if (item.isRefined) rs.refine(item.value);
                    });
                });
            }
        });

        // Celluma concern chips: a refinement list on `filter_von_concern` that the per-card chips toggle. Added before hits so _activeConcerns is up to date when cards render
        if (LAYOUT === 'celluma') {
            var concernRefinement = window.instantsearch.connectors.connectRefinementList(
                function (renderState) {
                    _concernRefine = renderState.refine;
                    _activeConcerns = {};
                    (renderState.items || []).forEach(function (item) {
                        if (item.isRefined) _activeConcerns[item.value] = true;
                    });
                }
            );
            _search.addWidgets([concernRefinement({
                attribute: getConcernField(),
                operator: 'or',
                limit: 200
            })]);

            // Toggle the concern facet when a card chip is clicked (don't follow the card link)
            document.addEventListener('click', function (e) {
                var chip = e.target.closest('.product-tile-concern');
                if (!chip) return;
                e.preventDefault();
                e.stopPropagation();
                if (_concernRefine) {
                    _scrollToTopPending = true;
                    _concernRefine(chip.dataset.concern);
                }
            });

            // Wishlist heart sits inside the tile link; stop the link from navigating (the Ultimate Wishlist app still handles the click to toggle)
            document.addEventListener('click', function (e) {
                if (e.target.closest('.celluma-tile .uwl-col-wishlist')) {
                    e.preventDefault();
                }
            });
        }

        // Active refinements (toggle per-group "Aufheben"; power "Clear All")
        var _currentRefinementsState = null;
        var renderCurrentRefinements = window.instantsearch.connectors.connectCurrentRefinements(
            function (renderState) {
                _currentRefinementsState = renderState;
                var refinedAttrs = {};
                (renderState.items || []).forEach(function (item) {
                    if (item.refinements && item.refinements.length) {
                        refinedAttrs[item.attribute] = true;
                    }
                });
                document.querySelectorAll('.filter-group').forEach(function (g) {
                    var attr = g.dataset.attribute;
                    var clearBtn = g.querySelector('.filter-group__clear');
                    if (clearBtn) clearBtn.style.display = refinedAttrs[attr] ? '' : 'none';
                });
            }
        );
        _search.addWidgets([renderCurrentRefinements({})]);

        // "Clear All" (Celluma modal footer): remove every active refinement
        document.addEventListener('click', function (e) {
            if (!e.target.closest('[data-ms-filter-clear-all]')) return;
            if (!_currentRefinementsState) return;
            _currentRefinementsState.items.forEach(function (item) {
                item.refinements.forEach(function (r) { _currentRefinementsState.refine(r); });
            });
        });

        // Sort
        if (LAYOUT === 'celluma') {
            // Celluma: a custom dropdown of <button> options + a label showing the active one
            var sortOptionEls = document.querySelectorAll('.celluma-sort-option');
            var sortValueEl = document.querySelector('.celluma-controls__sort-value');
            var sortDropdownEl = document.querySelector('.celluma-sort-dropdown');
            if (sortOptionEls.length) {
                var cSortItems = [{ label: '__default__', value: DEFAULT_SORT }];
                sortOptionEls.forEach(function (el) {
                    if (el.dataset.value) cSortItems.push({ label: el.textContent.trim(), value: MEILISEARCH_INDEX + ':' + el.dataset.value });
                });

                var renderCellumaSort = window.instantsearch.connectors.connectSortBy(
                    function (renderState, isFirstRender) {
                        if (isFirstRender) {
                            sortOptionEls.forEach(function (el) {
                                el.addEventListener('click', function () {
                                    var v = el.dataset.value;
                                    renderState.refine(v ? MEILISEARCH_INDEX + ':' + v : DEFAULT_SORT);
                                    if (sortDropdownEl) sortDropdownEl.classList.remove('is-open');
                                });
                            });
                        }
                        var cur = renderState.currentRefinement;
                        sortOptionEls.forEach(function (el) {
                            var val = el.dataset.value ? MEILISEARCH_INDEX + ':' + el.dataset.value : DEFAULT_SORT;
                            var active = val === cur;
                            el.classList.toggle('is-active', active);
                            if (active && sortValueEl) sortValueEl.textContent = el.textContent.trim();
                        });
                    }
                );
                _search.addWidgets([renderCellumaSort({ items: cSortItems })]);
            }
        } else {
            var sortSelect = document.querySelector('.collection-sort__select');
            if (sortSelect) {
                var sortItems = [{ label: '__default__', value: DEFAULT_SORT }];
                Array.prototype.forEach.call(sortSelect.options, function (opt) {
                    if (opt.value) sortItems.push({ label: opt.textContent.trim(), value: MEILISEARCH_INDEX + ':' + opt.value });
                });

                var renderSortBy = window.instantsearch.connectors.connectSortBy(
                    function (renderState, isFirstRender) {
                        if (isFirstRender) {
                            sortSelect.addEventListener('change', function () {
                                var v = sortSelect.value;
                                renderState.refine(v ? MEILISEARCH_INDEX + ':' + v : DEFAULT_SORT);
                            });
                        }
                        var cur = renderState.currentRefinement;
                        if (cur && cur !== DEFAULT_SORT) {
                            sortSelect.value = cur.replace(MEILISEARCH_INDEX + ':', '');
                        }
                    }
                );
                _search.addWidgets([renderSortBy({ items: sortItems })]);
            }
        }

        // Hits
        var _searchInFlight = false;
        var _scrollToTopPending = false;
        _search.on('search', function () { _searchInFlight = true; });
        _search.on('render', function () {
            _searchInFlight = false;
            if (_scrollToTopPending) {
                _scrollToTopPending = false;
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    });
                });
            }
        });
        _search.on('error', function () { _searchInFlight = false; _scrollToTopPending = false; revealSection(); });

        var renderHits = window.instantsearch.connectors.connectHits(
            function (renderState) {
                var container = document.getElementById('product-grid');
                if (!container) return;
                var hits = renderState.hits;
                var results = renderState.results;

                if (hits.length > 0) {
                    // Kick off the AICO price request for the first screenful before the heavy innerHTML render, so the network round-trip overlaps it
                    if (LAYOUT !== 'celluma') prefetchAicoFromHits(hits);
                    container.innerHTML = hits.map(renderHit).join('');
                    revealSection();
                    if (LAYOUT !== 'celluma') { applyAicoAll(); observeAicoCards(); }
                    return;
                }
                if (_searchInFlight) return;
                if (results && results.nbHits === 0) {
                    container.innerHTML = '<li class="product-grid__empty">' + escapeHtml(T_NO_RESULTS) + '</li>';
                    revealSection();
                }
            }
        );
        _search.addWidgets([renderHits({})]);

        // Total products count (Celluma "X Products"); harmless if absent
        var renderStats = window.instantsearch.connectors.connectStats(
            function (renderState, isFirstRender) {
                if (isFirstRender) return;
                var nb = renderState.nbHits || 0;
                document.querySelectorAll('.collection-total-products')
                    .forEach(function (el) { el.textContent = nb; });
            }
        );
        _search.addWidgets([renderStats({})]);

        // Pagination
        var _paginationRefine = null;
        var renderPagination = window.instantsearch.connectors.connectPagination(
            function (renderState) {
                var container = document.querySelector('.pagination__list');
                if (!container) return;
                _paginationRefine = renderState.refine;

                var pages = renderState.pages;
                var current = renderState.currentRefinement;
                var nbPages = renderState.nbPages;
                var createURL = renderState.createURL;
                var isFirst = renderState.isFirstPage;
                var isLast = renderState.isLastPage;

                if (nbPages <= 1) { container.innerHTML = ''; return; }

                var html = '';
                html += '<li class="pagination__item pagination__item--prev' + (isFirst ? ' pagination__item--disabled' : '') + '">' +
                    '<a href="' + createURL(current - 1) + '" data-page="' + (current - 1) + '" aria-label="Previous">&lsaquo;</a></li>';
                pages.forEach(function (page) {
                    html += '<li class="pagination__item' + (page === current ? ' pagination__item--active' : '') + '">' +
                        '<a href="' + createURL(page) + '" data-page="' + page + '">' + (page + 1) + '</a></li>';
                });
                html += '<li class="pagination__item pagination__item--next' + (isLast ? ' pagination__item--disabled' : '') + '">' +
                    '<a href="' + createURL(current + 1) + '" data-page="' + (current + 1) + '" aria-label="Next">&rsaquo;</a></li>';
                container.innerHTML = html;
            }
        );
        _search.addWidgets([renderPagination({ padding: 2 })]);

        document.addEventListener('click', function (e) {
            var link = e.target.closest('.pagination__list a[data-page]');
            if (!link) return;
            e.preventDefault();
            if (!_paginationRefine) return;
            var page = parseInt(link.dataset.page, 10);
            if (isNaN(page) || page < 0) return;
            _scrollToTopPending = true;
            _paginationRefine(page);
        });

        _search.start();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSearch);
    } else {
        initSearch();
    }
})();
